import React from "react";
import Radium from "radium";
import * as s from "../styles/website";

const MovedBanner = () => {
    return (
        <aside style={s.movedBanner}>
            <span aria-hidden="true">👋</span> I've moved! My work continues at{" "}
            <a style={s.movedBannerLink} href="https://valkev.tech">valkev.tech →</a>
        </aside>
    );
}

export default Radium(MovedBanner);
